var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "languageHome" }, [
    _c(
      "div",
      { staticClass: "selectLanguage", on: { click: _vm.toggleSelect } },
      [_c("md-icon", [_vm._v("language")])],
      1
    ),
    _vm._v(" "),
    _vm.isSelectionTrue
      ? _c(
          "ul",
          { staticClass: "languageList", on: { mouseleave: _vm.selectBlur } },
          _vm._l(_vm.languages, function (lang) {
            return _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    return _vm.languageSelect(lang.code)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c("country-flag", {
                      class: {
                        selected: lang.code === _vm.$i18n.locale,
                      },
                      style: { borderRadius: "5px" },
                      attrs: {
                        country:
                          lang.code === "en"
                            ? "us"
                            : lang.code === "ar"
                            ? "sa"
                            : lang.code,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "justify-content-end pl-3 cursorPointer popoverFont",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(lang.name) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }